export class Error {
  constructor(
    public message: string,
  ) { }
}
